import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { motion } from "framer-motion";
import { Button, useTheme, Box } from "@mui/material";
import { tokens } from "../../theme";
import Axios from 'axios';
import { getAuthHeader } from '../../utils/authToken';
import ReplaceTextbookModal from './ReplaceTextbookModal';

const TextbookCard = ({ 
    textbook,
    setSuccessAlertOpen,
    setSuccessAlertMessage,
    setErrorAlertOpen,
    setErrorAlertMessage,
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [replaceOpen, setReplaceOpen] = React.useState(false);

    async function handleDelete(e, id) {
        e.preventDefault();

        if (!window.confirm("Are you sure you want to delete this textbook?")) {
            return;
        }

        await Axios.delete(`${process.env.REACT_APP_URL}/api/v1/textbooks/${id}`, {
            headers: {
                Authorization: getAuthHeader(),
            },
        }).then((response) => {
            setSuccessAlertMessage(response.data.message);
            setSuccessAlertOpen(true);
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }).catch((error) => {
            setErrorAlertMessage(error.response?.data?.message || "Something went wrong");
            setErrorAlertOpen(true);
        });
    }

    return (
        <motion.div
            animate={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            exit={{ opacity: 0 }}
            layout
        >
            <Card
                sx={{
                    minWidth: 260,
                    maxWidth: 260,
                    minHeight: 230,
                    maxHeight: 230,
                    backgroundColor: colors.primary[600],
                    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.5)",
                    border: `1px solid ${colors.primary[600]}`,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    padding: "14px",
                    ":hover": {
                        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.5)",
                        border: "1px solid grey",
                    }
                }}
                key={textbook.id}
            >
                <CardContent sx={{ padding: 0, marginBottom: 2, flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <Typography variant="h5" sx={{ mb: 1.5 }}>
                        <a href={textbook.file_url} target="_blank" style={{'textDecoration': 'none'}}>
                            {textbook.title}
                        </a>
                    </Typography>
                    <Box>
                        <Typography color="text.secondary">
                            {textbook.subject_1}
                        </Typography>
                        <Typography color="text.secondary">
                            {textbook.subject_2}
                        </Typography>
                        {textbook.subject3 !== null && textbook.subject3 !== "" ? (
                            <Typography color="text.secondary">
                                {textbook.subject_3}
                            </Typography>
                        ) : null}
                        {textbook.subject4 !== null && textbook.subject4 !== "" ? (
                            <Typography color="text.secondary">
                                {textbook.subject_4}
                            </Typography>
                        ) : null}
                        <Typography color="text.secondary">
                            {textbook.pages ? "Total " + textbook.pages + " Pages" : "N/A"}
                        </Typography>
                    </Box>
                </CardContent>
                <CardActions
                    sx={{
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        flexWrap: "nowrap",
                    }}
                >
                    <Button
                        href={'/admin/textbooks/' + textbook.id}
                        size="small"
                        sx={{
                            backgroundColor: colors.primary[800],
                            color: colors.primary[400],
                            whiteSpace: "nowrap",
                            minWidth: 0,
                            px: 1,
                            flex: 1,
                        }}
                    >
                        View Exs
                    </Button>
                    <Button
                        size="small"
                        onClick={() => setReplaceOpen(true)}
                        sx={{
                            backgroundColor: colors.primary[700],
                            color: colors.primary[400],
                            whiteSpace: "nowrap",
                            minWidth: 0,
                            px: 1,
                            flex: 1,
                        }}
                    >
                        Replace
                    </Button>
                    <Button
                        size="small"
                        onClick={(e) => handleDelete(e, textbook.id)}
                        sx={{
                            backgroundColor: colors.redAccent[600],
                            color: colors.primary[400],
                            whiteSpace: "nowrap",
                            minWidth: 0,
                            px: 1,
                            flex: 1,
                        }}
                    >
                        Delete
                    </Button>
                </CardActions>
            </Card>
            <ReplaceTextbookModal
                open={replaceOpen}
                onClose={() => setReplaceOpen(false)}
                textbook={textbook}
                onSuccess={() => setTimeout(() => window.location.reload(), 800)}
                setSuccessAlertOpen={setSuccessAlertOpen}
                setSuccessAlertMessage={setSuccessAlertMessage}
                setErrorAlertOpen={setErrorAlertOpen}
                setErrorAlertMessage={setErrorAlertMessage}
            />
        </motion.div>
    )
}

export default TextbookCard